/**
 * Based on mxgraph 4.2.0
 */
import mxgraphFactory from "mxgraph";
import { MxGraphNS } from './mxgraph-types';

const mxAbsolutePath = "/platform/runtime/common/web/@edp-pmf/mxgraph";

const topWindow = window.top;
const gspframeworkService = topWindow.gspframeworkService;
const igixBasePath = gspframeworkService && gspframeworkService.common && gspframeworkService.common.getBasePath && gspframeworkService.common.getBasePath.get ? gspframeworkService.common.getBasePath.get() : "";

window['mxiGIXBasePath'] = igixBasePath || "";
window['mxBasePath'] = window['mxBasePath'] || (window['mxiGIXBasePath'] + mxAbsolutePath);
window['mxLoadResources'] = window['mxLoadResources'] || undefined;
window['mxForceIncludes'] = window['mxForceIncludes'] || undefined;
window['mxResourceExtension'] = window['mxResourceExtension'] || undefined;
window['mxLoadStylesheets'] = window['mxLoadStylesheets'] || undefined;
window['imageBasePath'] = window['imageBasePath'] || undefined;
const lang = window['mxLanguage'] || gspframeworkService && gspframeworkService.rtf && gspframeworkService.rtf.language && gspframeworkService.rtf.language.getLanguageCode && gspframeworkService.rtf.language.getLanguageCode() || localStorage.getItem('languageCode') || 'zh-CHS';
window['mxLanguage'] = lang && String(lang).replace("-", "").toLocaleLowerCase();
window['mxDefaultLanguage'] = window['mxDefaultLanguage'] || undefined;
window['mxLanguages'] = window['mxLanguages'] || undefined;

export const mxgraphInstance: typeof MxGraphNS = mxgraphFactory({});